/**
 * Le nombre d'une pastille : au-delà du plafond, il ne se lit plus et s'écrit « 9+ ». Neuf par
 * défaut, la règle du legacy pour les non-lus ; un onglet, qui a la place de deux chiffres, passe 99.
 */
export const cappedCount = (count: number, max = 9): string => (count > max ? `${max}+` : String(count))
